import React, { Component } from "react"
import PropTypes from "prop-types"
import { StaticQuery, graphql } from "gatsby"
import linkHandler from "../../helpers/storyblokLinkHandler"
import { addCookieData } from "../../helpers/handleCookies"

const postscribe = typeof window !== "undefined" ? require("postscribe") : null

const MailchimpForm = ({ formUuid }) => (
    <StaticQuery
        query={graphql`
      query {
        allStoryblokEntry(
          filter: { full_slug: { regex: "/^hult/config/mailchimp//" } }
        ) {
          edges {
            node {
              uuid
              content
            }
          }
        }
      }
    `}
        render={(data) => {
            let form


            if (data && data.allStoryblokEntry) {
                data.allStoryblokEntry.edges.filter((e) => {

                    if (e.node.uuid === formUuid) {
                        const dataParse = JSON.parse(e.node.content)
                        const { embededForm } = dataParse

                        return (form = embededForm)
                    }
                    return form
                })
            }
            return form && <div dangerouslySetInnerHTML={{ __html: form }} />
        }}
    />
)

class FormMailChimp extends Component {
    componentDidMount() {
        const { campaignId, redirect_url } = this.props.blok
        const cookies = addCookieData()

        if (postscribe) {
            postscribe(
                "#mailchimp-form",
                `<script type='text/javascript' src='//s3.amazonaws.com/downloads.mailchimp.com/js/mc-validate.js'></script>`
            )
        }

        this.addField("CAMPAIGNID", campaignId)
        this.addField("UTM_CAMP", cookies.webCampaign)
        this.addField("UTM_MEDIUM", cookies.webMedium)
        this.addField("UTM_TERM", cookies.webTerm)
        this.addField("UTM_CONTEN", cookies.webContent)
        this.addField("UTM_SOURCE", cookies.partnerCode)
        this.addField("QUALS", "True")
        this.addField("PRACTICETY", "Qualifications")
        this.addField("PRODINT", "Ashridge")
        this.addField("CHANNEL", "Web")


        // GA Tracking
        document.getElementById("mc-embedded-subscribe").onclick = function () {
            setTimeout(function () {
                if (document.getElementById("mce-success-response").innerHTML !== "") {


                      window.dataLayer.push({
                        event: "hultedu_submitForm",
                        eventMeta: {
                          content: "ASH_CONT",
                          timestamp: JSON.stringify(new Date()),
                        },
                      })
                      if (redirect_url.cached_url !== ""){
                          window.location.href = linkHandler(redirect_url)
                      }
                }
                else {
                    console.log("error")
                }
            }, 3000);
        };
    }

    addField = (elementId, value) => {
        if (value) {
            const inputEl = `
        <div class="mc-field-group__hidden">
        <label for="mce-${elementId}">${elementId} (do not modify) </label>
        <input type="text" value="${value}" name="${elementId}" class="" id="mce-${elementId}">
        </div>`

            const fieldEl = document.getElementsByClassName("mc-field-group")[0]
            fieldEl.insertAdjacentHTML("afterend", inputEl)
        }
    }



    render() {
        const { blok } = this.props

        return (
            <div id="mailchimp-form" className="mailchimp-form">
                {blok && <MailchimpForm formUuid={blok.form} />}
            </div>
        )
    }
}

FormMailChimp.propTypes = {
    blok: PropTypes.shape({}).isRequired,
}

export default FormMailChimp
